import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import DGTable from 'jquery.dgtable';
import i18n, { t }  from '../../i18n/i18n.js';
import View from '../../../controls/View.js';
import Filter from '../../../controls/Filter.js';
import FiltersController from '../../../appHelpers/FiltersController.js';
import DropDownBox from '../../../controls/DropDownBox.js';
import NTP from '../../../utils/NTP.js';
import ResizeManager from '../../../utils/ResizeManager.js';
import app from '../../App.js';
import EmptyScreenUI from '../../../appHelpers/EmptyScreenMessages.js';
import TableContextMenuUtil from '../../../appHelpers/TableContextMenu.js';
import TimeFormatters from '../../../appHelpers/TimeFormatters.js';

var openEndedTimeSpan = function (timeFrom, timeTo) {
    var nowDate = NTP.date();
    return (timeFrom && (!timeTo || timeTo < timeFrom) ? (nowDate - Math.max(timeFrom, nowDate.dateWithZeroTime())) / 1000 : 0);
};

/** @class UserInfoReportPage */
const UserInfoReportPage = View.extend(
    /** @lends UserInfoReportPage.prototype */
    {

        className: 'main-body',

        /** @constructs */
        initialize: function () {

            var that = this;

            // Add the title for this screen
            var $title = $('<div class="main-title">').appendTo(that.$el);
            $('<h1 class="main">').text(t('userinfo_report.title')).appendTo($title);

            // Setup the space for action buttons
            var $buttonsBar = $('<div class="action-buttons">').append(
                $('<button class="action-refresh-button">').attr('title', t('refresh')).on('click', that.reload.bind(that))
            ).appendTo($title);

            // Create the dropdown for the download actions
            that.downloadDdl = new DropDownBox({ className: 'dropdown-action-download-box', defaultText: '', allowEmpty: true,
                position: 'end top',
                anchor: 'end bottom' })
                .addItem('csv', t('export_options', 'csv'))
                .addItem('xml', t('export_options', 'xml'));
            that.listenTo(that.downloadDdl, 'change', function () {
                var action = that.downloadDdl.val();
                that.downloadDdl.val(null);

                if (action === 'csv') {
                    that.exportAction(action);
                } else if (action === 'xml') {
                    that.exportAction(action);
                }

            });
            that.downloadDdl.$el.appendTo($buttonsBar);

            // Add the filters area
            that.$filtersArea = $('<div class="filters-area">').appendTo(that.$el).on('resize', function(){
                that.adjustSplitFrame();
            });

            // Create the space for the table and its preview data
            that.$splitArea = $('<div class="report-split-area"><div class="table-wrapper"></div><div class="data-area"></div></div>').appendTo(that.$el);

            // Setup the filters
            that.setupFilters();

            // Setup the table, and its automatic adjusting to its frame
            that.setupTable();
            that.table.render();
            that.listenTo(ResizeManager, 'resize', that.adjustSplitFrame);
            that.setTimeout(function () { that.adjustSplitFrame(); }, 0);

            that.reload();
        },

        setupFilters: function () {
            var that = this;

            var getLastDaysDates = function(date, days) {

                var dates = [{
                    'label': t('filter_date_options.today'),
                    'value': date.toLocalISODateString()
                }];

                date.setHours(date.getHours() - 24);
                dates.push({
                    'label': t('filter_date_options.yesterday'),
                    'value': date.toLocalISODateString()
                });

                for ( var i = 2; i < (days || 30); i++ ) {

                    date.setHours(date.getHours() - 24);
                    dates.push({
                        'label': date.toLocalISODateString(),
                        'value': date.toLocalISODateString()
                    })

                }

                return dates;
            };

            var getFilterIds = function (key) {
                return (((that._filters.getValues(key, true) || {})[key] || {})['value'] || []).map(x => x.value).join(',');
            };

            var filterConfiguration = {
                'team_id': {
                    label: t('filters.team'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'fields': 'id,name'
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('teams', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: value['name']
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    },
                    cacheSource: true
                },
                'user_id': {
                    label: t('filters.user_representative'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'fields': 'id,first_name,last_name',
                            'team_id': getFilterIds('team_id')
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('users', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: ((value['first_name'] || '') + ' ' + (value['last_name'] || '')).trim()
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    },
                    cacheSource: true
                },
                'date': {
                    label: t('filters.date'),
                    type: Filter.FilterType.OPTION,
                    source: getLastDaysDates(NTP.date()),
                    sortItems: false,
                }
            };

            var queryFilters = null;
            var queryString = Backbone.history.getFragment().getQueryStringParams();
            if (queryString['filters']) {
                try {
                    queryFilters = JSON.parse(decodeURIComponent(atob(queryString['filters'])));
                } catch (e) { }
            }

            that._filters = new FiltersController({
                config: filterConfiguration,
                util: {
                    i18n: i18n,
                    getUserSetting: app.getUserSetting,
                    setUserSetting: app.setUserSetting,
                },
                saveKey: 'userinfo_report',
                startWithValues: queryFilters,
                $panel: that.$filtersArea,
                defaults: {
                    'date': { 'value': [{ 'value': NTP.date().toLocalISODateString(), 'label': t('filter_date_options.today')}] }
                },
                callback: function (filterValues, type, action, value, andValue, mode) {
                    that.reload();
                    if (type === 'team_id') {
                        that._filters
                            .clearAutoCompleteCache('user_id')
                            .clearAutoCompleteCache('project_id')
                            .clearAutoCompleteCache('campaign_id');
                    }
                    else if (type === 'user_id') {
                        that._filters
                            .clearAutoCompleteCache('project_id')
                            .clearAutoCompleteCache('campaign_id');
                    }
                    else if (type === 'project_id') {
                        that._filters
                            .clearAutoCompleteCache('campaign_id');
                    }
                }
            });

            return that;
        },

        setupTable: function () {
            var that = this;

            var columns = [
                {name: 'id', label: t('userinfo_report.columns.user_id')},
                {name: 'user_fullname', label: t('userinfo_report.columns.user_fullname')},
                {name: 'username', label: t('userinfo_report.columns.username')},
                {name: 'team_name', label: t('userinfo_report.columns.team_name')},
                {name: 'call_count', label: t('userinfo_report.columns.call_count')},
                {name: 'answered_call_count', label: t('userinfo_report.columns.answered_call_count')},
                {name: 'saved_sessions', label: t('userinfo_report.columns.saved_sessions')},
                {name: 'closed_orders', label: t('userinfo_report.columns.closed_orders')},
                {name: 'gross_call_duration', label: t('userinfo_report.columns.gross_call_duration')},
                {name: 'net_call_duration', label: t('userinfo_report.columns.net_call_duration')},
                {name: 'call_duration_avg', label: t('userinfo_report.columns.call_duration_avg')},
                {name: 'personal_break_duration', label: t('userinfo_report.columns.personal_break_duration')},
                {name: 'logged_in_duration', label: t('userinfo_report.columns.logged_in_duration')}
            ];

            var tableConfigKey = 'userinfo_report';
            app.TableAutoSavingConfigUtil.load(columns, tableConfigKey);

            var dateFormat = t('date_formats.normal_date_short_time');

            var table = that.table = new DGTable({
                el: that.$splitArea.find('.table-wrapper')[0],
                columns: columns,
                width: DGTable.Width.SCROLL,
                convertColumnWidthsToRelative: true,
                cellFormatter: function (val, colName, row) {
                    if (colName === 'user_fullname') {

                        return (row['user_first_name'] || '') + ' ' + (row['user_last_name'] || '');

                    } else if (colName === 'call_duration_avg') {

                        return TimeFormatters.timeFromSeconds(Math.round((row['net_call_duration'] / row['answered_call_count']) || 0));

                    } else if (colName === 'gross_call_duration') {

                        return TimeFormatters.timeFromSeconds(row['gross_call_duration']);

                    } else if (colName === 'net_call_duration') {

                        return TimeFormatters.timeFromSeconds(row['net_call_duration']);

                    } else if (colName === 'personal_break_duration') {

                        row['total_personal_break_duration'] = row['personal_break_duration'] +
                            (row['break_type'] === 'personal' ? openEndedTimeSpan(row['break_start_time']) : 0);

                        return TimeFormatters.timeFromSeconds(row['total_personal_break_duration']);

                    } else if (colName === 'logged_in_duration') {

                        return TimeFormatters.timeFromSeconds(row['logged_in_duration'] +
                            openEndedTimeSpan(row['last_login_time'], row['last_logout_time']));

                    } else if (colName === 'saved_sessions') {

                        return '<a href="/admin/reports/call_events?filters=' + encodeURIComponent(btoa(encodeURIComponent(JSON.stringify({
                            'user_id': {
                                'value': [
                                    {
                                        'value': row['id'],
                                        'label': ((row['user_first_name'] || '') + ' ' + (row['user_last_name'] || '')).trim()
                                    }
                                ]
                            },
                            'end_time': {
                                'mode': '=',
                                'value': row['date']
                            }
                        })))) + '">' + val + '</a>';
                    }
                    return val;
                },
                comparatorCallback: function (columnName, descending) {
                    var leftValue = descending ? 1 : -1,
                        rightValue = descending ? -1 : 1;
                    if (columnName === 'user_fullname') {
                        return function (a, b) {
                            if (a['user_first_name'] < b['user_first_name']) return leftValue;
                            if (a['user_first_name'] > b['user_first_name']) return rightValue;
                            if (a['user_last_name'] < b['user_last_name']) return leftValue;
                            if (a['user_last_name'] > b['user_last_name']) return rightValue;
                            return 0;
                        };
                    }
                    else if (columnName === 'call_duration_avg') {
                        return function (a, b) {
                            a = (a['net_call_duration'] / a['answered_call_count']) || 0;
                            b = (b['net_call_duration'] / b['answered_call_count']) || 0;
                            if (a < b) return leftValue;
                            if (a > b) return rightValue;
                            return 0;
                        };
                    }
                    else if (columnName === 'personal_break_duration') {
                        return function (a, b) {
                            a = a['personal_break_duration'] +
                                (a['break_type'] === 'personal' ? openEndedTimeSpan(a['break_start_time']) : 0);
                            b = b['personal_break_duration'] +
                                (b['break_type'] === 'personal' ? openEndedTimeSpan(b['break_start_time']) : 0);
                            if (a < b) return leftValue;
                            if (a > b) return rightValue;
                            return 0;
                        };
                    }
                    else if (columnName === 'logged_in_duration') {
                        return function (a, b) {
                            a = a['logged_in_duration'] + openEndedTimeSpan(a['last_login_time'], a['last_logout_time']);
                            b = b['logged_in_duration'] + openEndedTimeSpan(b['last_login_time'], b['last_logout_time']);
                            if (a < b) return leftValue;
                            if (a > b) return rightValue;
                            return 0;
                        };
                    }
                    return null;
                }
            });

            app.TableAutoSavingConfigUtil.setup(table, tableConfigKey);

            table.on('rowcreate', function (filteredIndex, index, row, rowData) {

                row.className += index % 2 ? ' alt-row' : ' normal-row';

                if (that._selectedRow && that._selectedRow['id'] === rowData['id']) {
                    row.className += ' selected';
                }
                $(row).click(function () {
                    handleRowSelection(row, row, rowData);
                });

            }).on('cellpreview', function (el, rowIndex, col, rowData) {

                $(el).click(function () {
                    handleRowSelection(el, table.getRowElement(rowIndex), rowData);
                });

            }).on('rowdestroy', function (row) {

            }).on('headercontextmenu', function (columnName, pageX, pageY, cellBounds) {
                TableContextMenuUtil.setup(table, pageX, pageY);
                $.disableContextMenuForCurrentEvent();
            });

            var handleRowSelection = function (el, row, rowData) {

                if (that._selectedRow && that._selectedRow['id'] === rowData['id']) {
                    that.setSelectedRow();
                } else {
                    if (that._selectedRow) {
                        $(row.parentNode).find('.dgtable-row').removeClass('selected');
                    }
                    row.className += ' selected';
                    that.setSelectedRow(rowData);
                }

                if ($(el).closest('.dgtable-cell-preview').length) {
                    that.table.hideCellPreview();
                }
            };

            return that;
        },

        adjustSplitFrame: function () {
            var that = this;
            //TODO: do something with the split area
            var $offsetParent = that.$splitArea.offsetParent();
            var offsetTop = that.$splitArea.offset().top - $offsetParent.offset().top;
            that.$splitArea.css({ 'height': $offsetParent.height() - offsetTop - 20 });

            if (that.table) {
                var lastTableSize = that._lastTableSize;
                var tableSize = {
                    width: that.table.$el.offsetParent().width(),
                    height: that.table.$el.offsetParent().height()
                };

                if (!lastTableSize || tableSize.height != lastTableSize.height) {
                    that.table.tableHeightChanged();
                } else if (!lastTableSize || tableSize.width != lastTableSize.width) {
                    that.table.tableWidthChanged();
                }
                that._lastTableSize = tableSize;
            }
            return that;
        },

        reload: function () {
            var that = this;

            var filters = that._filters.getValues(true);

            var noDataMessage = function (message) {

                that.table.setRows([], true);

                if (that._loadXhr) {
                    that._loadXhr.abort();
                    that._loadXhr = null;

                    app.AlertUI.hideLoader(that.$el.closest('.main-body'));
                }

                that.setTimeout(function () {

                    if ( (!filters || !Object.keys(filters).length || !filters['date'])
                        || ( filters['date']['value'] && filters['date']['value'].length > 1 ) ){

                        EmptyScreenUI.showEmptyScreenMessages(that.$el.closest('.main-body'), message);

                    }

                }, 0);

                return that;

            };

            //Verify that a date filter is given
            if (!filters || !Object.keys(filters).length || !filters['date']) {

                return noDataMessage(t('choose_dates_filter_screen_message'));

                //Else: Verify that only 1 date filter has been choose
            } else if ( filters['date']['value'] && filters['date']['value'].length > 1 ) {

                return noDataMessage(t('only_one_date_filter_screen_message'));

            } else {
                EmptyScreenUI.hideEmptyScreenMessages(that.$el.closest('.main-body'));
            }

            if (that._isLoading) return that;

            var fields = [
                'user_id',
                'user_first_name',
                'user_last_name'
            ];
            fields = fields.join(',');

            that._isLoading = true;
            that.ajaxGet(app.apiUrl('userinfo'), { 'fields': fields, 'filters': JSON.stringify(that._filters.getValues(true)) })
                .always(function () {
                    that._isLoading = false;
                })
                .then(function (data) {
                    that.table.setRows(data, true);

                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });

            return that;
        },

        render: function () {

            var that = this;

            return this;
        },

        setSelectedRow: function (row) {
            var that = this;
            that._selectedRow = row;

            if (!!row !== that.$splitArea.hasClass('is-split')) {
                that.$splitArea.toggleClass('is-split');
                that.table.tableHeightChanged();
            }

            that.$splitArea.find('.data-area').empty();

            if (!row) {
                return that;
            }

            return that;
        },

        /**
         *
         * @param {String} format
         */
        exportAction: function (format) {
            var that = this;

            var exportLoc = {
                'columns': t('userinfo_report.columns')
            };

            var exportColumns = that.table.getColumnsConfig();
            exportColumns = Object.keys(exportColumns).filter(function (col) {
                return col !== 'actions' && exportColumns[col].visible !== false;
            }).sort(function (a, b) {
                a = exportColumns[a].order;
                b = exportColumns[b].order;
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            });

            var url = app.apiUrl('userinfo', {
                'export': format,
                'export_columns': exportColumns.join(','),
                'export_lang': i18n.getActiveLanguage(),
                'export_loc': JSON.stringify(exportLoc),
                'filters': JSON.stringify(that._filters.getValues(true))
            });

            var iframe = $('<iframe>').hide().appendTo(document.body).attr('src', url)
                .on('load', function () {
                    // If the IFrame is loaded, then an error has occurred...
                    var responsJSON = null;
                    try {
                        responsJSON = iframe[0].contentDocument.body.textContent;
                        responsJSON = JSON.parse(responsJSON);
                    } catch (e) {

                    }
                    if (responsJSON && responsJSON['error']) {
                        app.showXhrError({ 'responseText': JSON.stringify(responsJSON) });
                    }
                });

            return that;
        },

        remove: function () {
            var that = this;

            if (that._filters) {
                that._filters.destroy();
            }

            that.constructor.__super__.remove.apply(this, arguments);
        }

    }
);

export default UserInfoReportPage;
